import functionCommon from "../common/function";
import CONSTANT from "../constant/constant";
import { newLeaveRequest } from "../services/newLeaveRequest.service";
import {
    availableTimeConstants,
    createLeaveDayConstants,
    employeeAndManagerLeaderConstants,
    leaveTypesConstants,
} from "../constant/newLeaveRequest.constants";

const _errorCode = CONSTANT.errorCode;

export const getEmployeeAndManagerLeader = (data) => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }
    return (dispatch) => {
        newLeaveRequest.listEmployeeAndManagerLeader(data).then((res) => {
            if (!res) return;
            switch (res["http_code"]) {
                case _errorCode.APISuccess:
                    dispatch(success(res.result));
                    break;
                case _errorCode.TOKENExpired:
                    functionCommon.logout();
                    break;
                case _errorCode.APIInvalids:
                    functionCommon.logout();
                    break;
                case _errorCode.ClientNotPermission:
                    functionCommon.logout();
                    break;
                default:
                    window.location = "/error/404";
            }
        });
    };
    function success(listEmployeeAndManagerLeader) {
        return { type: employeeAndManagerLeaderConstants.GET_SUCCESS, listEmployeeAndManagerLeader };
    }
};

export const getAvailableTime = (data) => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }
    return (dispatch) => {
        newLeaveRequest.listAvailableTime(data).then((res) => {
            if (!res) return;
            switch (res["http_code"]) {
                case _errorCode.APISuccess:
                    dispatch(success(res.result));
                    break;
                case _errorCode.TOKENExpired:
                    functionCommon.logout();
                    break;
                case _errorCode.APIInvalids:
                    functionCommon.logout();
                    break;
                case _errorCode.ClientNotPermission:
                    functionCommon.logout();
                    break;
                default:
                    window.location = "/error/404";
            }
        });
    };
    function success(listAvailableTime) {
        const listAvailable = listAvailableTime;
        return { type: availableTimeConstants.GET_SUCCESS, listAvailable };
    }
};

export const deleteAailableTime = () => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }
    return (dispatch) => {
        dispatch(deleteTime());
    };
    function deleteTime() {
        const dataAailableTime = [];
        return { type: availableTimeConstants.DELETE, dataAailableTime };
    }
};

export const getLeaveTypes = (data) => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }
    return (dispatch) => {
        newLeaveRequest.listLeaveType(data).then((res) => {
            if (!res) return;
            switch (res["http_code"]) {
                case _errorCode.APISuccess:
                    dispatch(success(res.result));
                    break;
                case _errorCode.TOKENExpired:
                    functionCommon.logout();
                    break;
                case _errorCode.APIInvalids:
                    functionCommon.logout();
                    break;
                case _errorCode.ClientNotPermission:
                    functionCommon.logout();
                    break;
                default:
                    window.location = "/error/404";
            }
        });
    };
    function success(listLeaveType) {
        const listLeave = listLeaveType;
        return { type: leaveTypesConstants.GET_SUCCESS, listLeave };
    }
};

export const createLeaveDay = (data) => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }
    return (dispatch) => {
        dispatch(loading())
        newLeaveRequest.createLeaveDay(data).then((res) => {
            if (!res) return;
            switch (res["http_code"]) {
                case _errorCode.APISuccess:
                    dispatch(success("004"));
                    window.location = "/my-leave-request";
                    break;
                case _errorCode.TOKENExpired:
                    functionCommon.logout();
                    break;

                case _errorCode.APIInvalids:
                    functionCommon.logout();
                    break;

                case _errorCode.APIDuplicate:
                    dispatch(failure(res["error_code"]));
                    break;

                case _errorCode.DBCanNotConnect:
                    window.location = "/error/404";
                    break;

                default:
                    window.location = "/error/404";
                    break;
            }
        });
    };

    function success(code) {
        return { type: createLeaveDayConstants.ADD_SUCCESS, code };
    }

    function failure(error) {
        return { type: createLeaveDayConstants.ADD_FAILURE, error };
    }

    function loading() {
        return { type: createLeaveDayConstants.ADD_LOADING };
    }
};

export const deleteErrorCodeLeaveDay = () => {
    if (functionCommon.checkRequestApiTime()) {
        return functionCommon.logout();
    }
    return (dispatch) => {
        dispatch(deleteErrorCode());
    };
    function deleteErrorCode() {
        const errorCode = "";
        return { type: createLeaveDayConstants.DELETE, errorCode };
    }
};
